import {
  batchQueryUploadStatus,
  cancelUpload,
  deleteUploadFile,
  postPrepareSimpleUpload,
  postPrepareUpload,
  queryUploadStatus,
} from '@rendora/common/entities/upload_media_v3';
import { useUserStore } from '@rendora/common/store';
import type { IDataSource } from './types';

const DataSource: IDataSource = {
  async prepare(data) {
    const resData = await postPrepareUpload(data);
    if (resData) {
      const { immobilization_prefix, secret_str, suffix } = resData;
      const { host, signed_key } = resData?.credential || {};
      const user_id = useUserStore().user?.user_id;
      resData.upload_path = `${immobilization_prefix}/${user_id}_${secret_str}.${suffix}`;
      if (resData.credential) {
        resData.credential.signed_url = `${host}${resData.upload_path}${signed_key}`;
      }
    }
    return resData;
  },
  async prepareSimpleUpload(data) {
    const resData = await postPrepareSimpleUpload(data);
    return resData;
  },
  async queryStatus(params) {
    return await queryUploadStatus(params);
  },
  async batchQuery(params) {
    return await batchQueryUploadStatus(params);
  },
  async cancel(data) {
    return await cancelUpload(data);
  },
  async remove(params) {
    await deleteUploadFile(params);
  },
};

export default DataSource;
